export const iconCodePoints = {
  account_circle: 'f20b',
  add: 'e145',
  arrow_back: 'e5c4',
  arrow_downward: 'e5db',
  arrow_forward: 'e5c8',
  arrow_upward: 'e5d8',
  book_2: 'f53e',
  bug_report: 'e868',
  business_center: 'eb3f',
  check: 'e668',
  check_circle: 'f0be',
  check_small: 'f88b',
  checklist: 'e6b1',
  close: 'e5cd',
  cloud_upload: 'e2c3',
  comment: 'e24c',
  content_copy: 'e14d',
  currency_yen: 'eafb',
  delete: 'e92e',
  description: 'e873',
  diamond: 'ead5',
  domain: 'e7ee',
  drag_indicator: 'e945',
  edit: 'f097',
  error: 'f8b6',
  exit_to_app: 'e879',
  favorite: 'e87e',
  filter_list: 'e152',
  format_list_bulleted: 'e241',
  group: 'ea21',
  help: 'e8fd',
  inbox: 'e156',
  key: 'e73c',
  keyboard_arrow_down: 'e313',
  keyboard_arrow_left: 'e314',
  keyboard_arrow_right: 'e315',
  keyboard_arrow_up: 'e316',
  keyboard_double_arrow_left: 'eac3',
  keyboard_double_arrow_right: 'eac9',
  launch: 'e89e',
  location_on: 'f1db',
  lock: 'e899',
  logout: 'e9ba',
  mail: 'e159',
  menu: 'e5d2',
  more_horiz: 'e5d3',
  note_add: 'e89c',
  open_in_new: 'e89e',
  picture_as_pdf: 'e415',
  print: 'e8ad',
  redo: 'e15a',
  refresh: 'e5d5',
  remove: 'e15b',
  school: 'e80c',
  search: 'ef7a',
  send: 'e163',
  settings: 'e8b8',
  star_shine: 'f31d',
  swap_vert: 'e8d5',
  sync: 'e627',
  travel_explore: 'e2db',
  trophy: 'ea23',
  view_agenda: 'e8e9',
  visibility: 'e8f4',
  visibility_off: 'e8f5',
  wand_stars: 'f31e',
  workspace_premium: 'e7af',
} satisfies Partial<Record<MaterialIconName, string>>

export type EnabledIconName = keyof typeof iconCodePoints

export const enabledIconNames = Object.keys(
  iconCodePoints,
) as EnabledIconName[]
